import fetch from 'isomorphic-fetch'
import qs from 'qs'
import uuid from 'uuid'
import { compressWidgets, b64toBlob, getEnv } from '../utils'
import {
  getResumeByOtpMock,
  getReuploadDocumentsMock,
  getThankYouPageMock
} from '../state/stateExtension'
//import Cookies from 'universal-cookie';


/**
 * Functions used to connect to the API server
 * @module API
 */

/**
 * The API root
 * @private
 */
const API_ROOT = process.env.API_ROOT
const PROMO_API_ROOT = process.env.PROMO_API_ROOT
const Onboard_API_ROOT=process.env.Onboard_API_ROOT

/**
 * The basic request
 * @private
 * @throws      NoGivenEndpointException
 * @param {Object} options              The options object
 * @param {string} options.endpoint     The endpoint to fetch
 * @param {string} options.method       The request method ['GET', ?POST', PUT', 'PATCH', 'DELETE'
 * @param {Object} options.body         The body to send in the request
 * @param {Object} options.headers      The request headers
 * @return {Promise}                    A fetch request
 */
export const request = ({ endpoint, method, body, headers, apiRoot } = {}) => {
  if (!headers) headers = { 'Content-Type': 'application/json' }
  if (!method) method = 'POST'
  if (endpoint === '') throw 'You need to pass an endpoint to fetch'
  if (apiRoot === undefined || apiRoot === null) apiRoot = API_ROOT

  //let uri=`${apiRoot}/${endpoint}`
  // @remarks uncomment to test mocked endpoints redescribing them in the stateExtension as full urls
  // uri = /:\/\//.test(endpoint) ? endpoint : `${API_ROOT}/${endpoint}`
  if(endpoint.indexOf('onboarding/upload') > -1) {
    headers = {
      ...headers,
      Cookie: 'key=value;' + document.cookie
    };
  }

  const req = {
    credentials: 'include',
    method,
    headers
  }
  if(endpoint.indexOf('PromoCodeManagement') > -1||endpoint.indexOf('OnboardRequestDetails') > -1)  //sandbox.gestpay.net
   {
      req.credentials=true
      delete req['credentials']
   }
   let uri = ''
   uri = (endpoint.indexOf('PromoCodeManagement') > -1||endpoint.indexOf('OnboardRequestDetails') > -1) ? `${PROMO_API_ROOT}/${endpoint}` : `${apiRoot}/${endpoint}`
   let onboardingURI=`${Onboard_API_ROOT}/onboarding/wgt`
   if (body) {
    if (method === 'GET' && body) {
      uri += `?${qs.stringify(body)}`
    } else if (headers['Content-Type'] === 'application/json') {
      req.body = JSON.stringify(body)
    } else {
      req.body = body  
    }
  }

 let ApiReqbody=""
  if(!req.body)
  {
    ApiReqbody=""
  }
  else 
  {
    ApiReqbody=req.body;
  }
  const apiRequestbody={
    ApiUrl:uri,
    ApiHttpMethod:req.method,
    ApiContent:ApiReqbody,
    ApiHeader:JSON.stringify(headers)
  }

  let apiRequest={
    credentials: 'include',
    body :JSON.stringify(apiRequestbody),
    method:'POST',
    //headers:JSON.stringify(req.headers)
    headers:{'Content-Type': 'application/json'}
   }

  if(endpoint.indexOf('OnboardRequestDetails') > -1 || endpoint.indexOf('PromoCodeManagement') > -1) {
    onboardingURI = uri;
    apiRequest = req;
  }

  if(endpoint.indexOf('wgt/document/upload')>-1 ||
    endpoint.indexOf('wgt/genericfiledoc/upload')>-1  ||
    endpoint.indexOf('wgt/contact/upload')>-1  ||
    endpoint.indexOf('wgt/genericdocument/upload')>-1 
    )
    {
      req.headers['ApiUrl']=uri;
      onboardingURI=`${Onboard_API_ROOT}/onboarding/upload`
      apiRequest = req;
    }

 return fetch(onboardingURI, apiRequest)
 //return fetch(uri,req)
    .then(res => {
      if((uri.endsWith('wgt/product/onboarding/next') || uri.endsWith('wgt/product/onboarding/back'))
        && res.status === 200) {
        window.scrollTo(0, 0);
      }
      if(headers['Content-Type'] === 'application/pdf') {
        res.text().then(text => {
          const fileName = extractFileNameFromUrl(endpoint);
          const fileContent = text.slice(1, -1);
          downloadPdf(fileName, fileContent);
          return true;
        });
      } else if (req.headers['Content-Type'] === 'application/image') {
        const json = {
          status: 'success',
          message: 'ok',
          data: { url: uri }
        }

        if (res.status >= 400) {
          json.status = 'error'
        }

        if (res.status === 404) {
          json.status = 'not_found'
        }

        return json
      } else if (
        res.headers.get('Content-Type').indexOf('application/json') > -1 ||
        (res.headers.get('Content-Type').indexOf('text/plain') > -1 &&
          headers['Content-Type'] === 'application/json')
      ) {
        // the second condition has been added to avoid misinterpretation of openAM response
        return res.json()
      } else {
        return res
      }
    })
    .catch(res => {
      // @hack for IE (can't handle redirect on ajax requests)
      if (
        res.message === 'Network request failed' &&
        res.name === 'TypeError'
      ) {
        return { status: 'redirect', message: '' }
      } else {
        return { status: 'error', message: 'unknown error' }
      }
    })
}

export const extractFileNameFromUrl = url => {
  let fileName = "";
  if(url) {
    let urlArr = url.split("/");
    fileName = urlArr[urlArr.length - 1];
  }
  return fileName;
}

export const base64ToArrayBuffer = base64 => {
  var binaryString = window.atob(base64);
  var binaryLen = binaryString.length;
  var bytes = new Uint8Array(binaryLen);
  for (var i = 0; i < binaryLen; i++) {
      var ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
  }
  return bytes;
}

export const downloadPdf = (fileName, base64) => {
  var byte = base64ToArrayBuffer(base64);
  var blob = new Blob([byte], {type: "application/pdf"});
  
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(blob);
    return;
  }

  var link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.download = fileName;
  link.click();
};

/**
 * Encrypts a proof using the yoox encoder
 * @public
 * @param  {Object} proof   The plain third party data container
 * @return {Promise}        Promise
 */
/*#Removed4POS*/
/*export const encryptYooxProof = proof => {
  const body = { value: proof }

  const endpoint = 'api/rest/FREE/encrypt/yoox'

  const apiRoot = API_ROOT.replace(/\/onboarding/, '')

  return request({ endpoint, body, apiRoot })
}*/

/**
 * Decrypts a proof using the yoox decoder
 * @public
 * @param  {Object} proof   The encrypted third party data container
 * @return {Promise}        Promise
 */
/*#Removed4POS*/
/*export const decryptYooxProof = proof => {
  const body = { value: proof.value }

  const endpoint = 'api/rest/FREE/decrypt/yoox'

  const apiRoot = API_ROOT.replace(/\/onboarding/, '')

  return request({ endpoint, body, apiRoot })
}*/

/**
 * Logs the provided state to the server and traces an invitation's referrer
 * @public
 * @param  {Object} invitation  The session containing the dispatched actions and updated states
 * @return {Promise}            The server response.jswon
 */
/*#Removed4POS*/
/*export const acceptInvitation = invitation => {
  // @remarks re-enable once the service will be ready to accept LOG types and get only the last invitation to populate the fields on step1
  // invitation.type = !!invitation.promoCode || !!invitation.campaignUrl || !!invitation.encryptedReporterId ? 'INVITATION' : 'LOG'
  invitation.type = 'INVITATION'
  // @remarks commented to avoid bad responses from the signaler services until it will be synced to the latest contract
  const body = invitation

  // const body = {
  //   type: invitation.type,
  //   contactId: invitation.contactId,
  //   promoCode: invitation.promoCode,
  //   campaignUrl: invitation.campaignUrl,
  //   encryptedReporterId: invitation.encryptedReporterId,
  //   codiceFiscale: invitation.codiceFiscale
  // }

  const endpoint = 'api/rest/FREE/onboarding/invitations'

  const apiRoot = API_ROOT.replace(/\/onboarding/, '')

  return request({ endpoint, body, apiRoot })
}*/

/**
 * Gets an invitation by contactId
 * @public
 * @param  {string} contactId   The contact's file id
 * @return {Promise}            The server response.json
 */
/*#Removed4POS*/
/*export const getInvitation = contactId => {
  const endpoint = `api/rest/FREE/onboarding/invitations?contactId=${contactId}&type=invitation&last=true`
  const method = 'GET'
  const apiRoot = API_ROOT.replace(/\/onboarding/, '')

  return request({ endpoint, method, apiRoot }).then(json => {
    json.data = json.data[0]
    return json
  })
}*/

/**
 * Gets all the invitations by contactId
 * @public
 * @param  {string} contactId   The contact's file id
 * @return {Promise}            The server response.json
 */
/*#Removed4POS*/
/*export const getInvitations = contactId => {
  const endpoint = `api/rest/FREE/onboarding/invitations?contactId=${contactId}&type=invitation`
  const method = 'GET'
  const apiRoot = API_ROOT.replace(/\/onboarding/, '')

  return request({ endpoint, method, apiRoot })
}*/

/**
 * OpenAM Auth
 * @public
 * @param {Object} body                   The callbacks to rebounce (empty obj on first call)
 * @return {Promise}                      The server response.json
 */
export const auth = body => {
  return request({ endpoint: 'auth/sso/json/authenticate', body }).then(
    json =>
      !!json.tokenId
        ? request({ endpoint: 'wgt/auth', body: {} })
          .then(() => json)
          .catch(() => json)
        : json
  )
}

/**
 * OpenAM UnAuth
 * @public
 * @param {Object} body                   The callbacks to rebounce (empty obj on first call)
 * @return {Promise}                      The server response.json
 */
export const unauth = () => {
  return request({ endpoint: 'wgt/unauth', body: {} })
    .then(() => json)
    .catch(() => json)
}

/**
 * Starts the onboarding process
 * @public
 * @param {string} partnership = 'HYPE'   The partnership code
 * @param {string} convention = 'ND'      The convention code
 * @param {Object} thirdPartyData         Third party init data
 * @return {Promise}                      The server response.json
 */
export const startOnboarding = (
  partnership = 'POS',
  convention = 'ND',
  thirdPartyData
) => {
  const p = partnership && partnership.toUpperCase()
  switch (p) {
    case 'POS_PERSONA_FISICA_EASYNOLO':
    case 'POS_DITTA_IND_EASYNOLO':
    case 'POS_AZIENDA_EASYNOLO':
    case 'POS_PERSONA_FISICA':
    case 'POS_DITTA_IND':
    case 'POS_AZIENDA':
      return request({
        endpoint: 'wgt/product/onboarding/start',
        body: { code: partnership, thirdPartyData }
      })
    default:
      return request({
        endpoint: `wgt/${partnership}/${convention}/start`,
        body: { data: thirdPartyData }
      })
  }
}

/**
 * Gets the form fields needed to resume the onboarding process
 * @public
 * @param {string} guid                   The guid of the session to recover
 * @return {Promise}                      The server response.json
 */
export const initResumeProcess = guid => {
  const body = { guid }
  return request({ endpoint: 'wgt/resume/start', body }).then(json => {
    if (json.status !== 'redirect' && json.status !== 'error') {
      return {
        ...json,
        isOtpCallback: true,
        step: { ...json.data.step, name: 'resume' },
        data: undefined
      }
    } else {
      return json
    }
  })
}

/**
 * Gets the form fields needed to get the contract list
 * @public
 * @param {string} guid                   The guid of the session to recover
 * @return {Promise}                      The server response.json
 */
export const initRecoveryProcess = () => {
  const body = {}
  return request({ endpoint: 'wgt/contact/start', body }).then(json => ({
    ...json,
    step: json.data.step
  }))
}

/**
 * Gets the contracts list (only after initRecoveryProcess has been launched)
 * @public
 * @return {Promise}                      The server response.json
 */
export const getUserRequests = () => {
  return request({ endpoint: 'wgt/contact/list' })
}

/**
 * Gets a pending contract
 * @public
 * @param {string} guid                   The guid of the contract to read
 * @return {Promise}                      The server response.json
 */
export const getContracts = guid => {
  const body = { guid }
  return request({ endpoint: 'wgt/contact/contract/list', body })
}

/**
 * Send the reuploaded document
 * @public
 * @param {string} guid                   The guid of the session to recover
 * @param {string} barCode1               The barcode of contarct document upload
 * @param {string} barCode2               The barcode of contarct document upload
 * @return {Promise}                      The server response.json
 */
export const completeReupload = (guid, barCode1, barCode2) => {
  const body = { guid, barCode1, barCode2 }
  return request({ endpoint: 'wgt/contact/sendpdf', body })
}

/**
 * Sends the OTP SMS needed to resume an onboarding contract
 * @public
 * @param {Boolean} forClosedContract     Specifies if the otp has to be sent for an open or closed contract
 * @return {Promise}                      The server response.json
 */
export const sendResumeOtpSms = forClosedContract => {
  if (!forClosedContract) {
    return request({ endpoint: 'wgt/resume/send/cell' })
  } else {
    return request({ endpoint: 'wgt/contact/send/cell' })
  }
}

/**
 * Requires the OTP SMS needed to resume an onboarding contract
 * @public
 * @param {Object} body                   The body containing the tern to access the contracts list
 * @param {string} guid                   The session guid
 * @return {Promise}                      The server response.json
 */
export const requireResumeOtpSms = (body, guid) => {
  return request({ endpoint: 'wgt/contact/next', body }).then(json => {
    const mock = getResumeByOtpMock(body, guid)

    mock.isOtpCallback = true
    mock.isContractClosed = true

    if (!!json && json.status === 'success' && !json.step) {
      return mock
    } else {
      return json
    }
  })
}

/**
 * Requires the component to reupload the document and resume onboarding contract
 * @public
 * @param {string}        guid            The session guid
 * @param {string}        barCode         The document barCode
 * @param {string}        docType         The document type
 * @param  {Boolean}      showSelfie      Establishes if the selfie widget should be added to the mock
 * @return {Promise}                      The server response.json
 */
export const initReuploadProcess = (guid, barCode, docType, showSelfie) => {
  const mock = getReuploadDocumentsMock(docType, showSelfie)

  mock.step.widgets.forEach(w => {
    w.components.forEach(c => {
      c.guid = guid
      c.barCode = barCode
    })
  })

  return mock
}

/**
 * Requires TYP mocked data
 * @public
 * @param  {string} contactId   The last session's contactId
 * @return {Object}             The step json
 */
export const initThankYouPage = (contactId, parentGuid) => {
  return getThankYouPageMock(contactId, parentGuid)
}

/**
 * Validates a resume OTP
 * @public
 * @param {string} otp                    The guid of the session to recover
 * @param {Boolean} forClosedContract     Specifies if the otp has to be sent for an open or closed contract
 * @return {Promise}                      The server response.json
 */
export const validateResumeOtp = (otp, forClosedContract) => {
  const body = { code: otp }
  if (!forClosedContract) {
    return request({ endpoint: 'wgt/resume/validate/cell', body })
  } else {
    return request({ endpoint: 'wgt/contact/validate/cell', body })
  }
}

/**
 * Resumes an onboarding contract after a successful OTP validation
 * @public
 * @return {Promise}                      The server response.json
 */
export const resumeProcess = () => {
  return request({ endpoint: 'wgt/resume' }).then(json => ({
    ...json,
    step: json.data && json.data.step,
    data: undefined
  }))
}

/**
 * Resumes an onboarding contract from the dossier list
 * @public
 * @param  {string}     guid              The session guid
 * @return {Promise}                      The server response.json
 */
export const resumeContactProcess = guid => {
  const body = { guid }

  return request({ endpoint: 'wgt/contact/resume', body }).then(json => ({
    ...json,
    step: json.data.step,
    data: undefined
  }))
}

/**
 * Gets the next step in the onboarding process
 * @public
 * @param {Object} widgets      The current widgets
 * @param {Object} components   The current components
 * @param {Number} stepNumber   The current onboarding step
 * @return {Promise}            The server response.json
 */
export const getNextStep = (widgets, components, stepNumber) => {
  let body = null
  if (widgets) {
    body = {
      step: {
        number: stepNumber,
        widgets: compressWidgets(widgets, components)
      }
    }
  }
  return request({ endpoint: 'wgt/product/onboarding/next', body })
}

/**
 * Gets the previous step in the onboarding process
 * @public
 * @return {Promise}      The server response.json
 */
export const getPrevStep = () => {
  return request({ endpoint: 'wgt/product/onboarding/back', method: 'GET' })
}

/**
 * Gets the product info
 * @public
 * @return {Promise}      The server response.json
 */
export const getProductInfo = () => {
  return request({ endpoint: 'wgt/product/info', method: 'GET' })
}

/**
 * Common API method to fetch data
 * @public
 * @param {string} url     The API endpoint to retrieve the options
 * @param {Object} body           Additional info to send with the request
 * @return {Promise}              The server response.json
 */
export const fetchAPIData = (url, body) => {
  return request({ endpoint: url, body }) /*.then(json => json.data)*/
}

/**
 * Fills all the selects with their options
 * @public
 * @param {string} optionsURL     The API endpoint to retrieve the options
 * @param {Object} body           Additional info to send with the request
 * @return {Promise}              The server response.json
 */
export const fetchSelectOptions = (optionsURL, body) => {
  return request({ endpoint: optionsURL, body }).then(json => json.data)
}

/**
 * Fills all the selects with their options
 * @public
 * @param {string} component          The component to validate
 * @param {Object} requiredValues     Values that the server needs to validate the component
 * @return {Promise}                  The new updated component with the server error messages
 */
export const getServerValidation = (component, requiredValues) => {
  // if (component.name === 'INDIRIZZO') {
  //   requiredValues.indirizzo = requiredValues.indirizzo.replace(
  //     /(\s+(?:\d+|snc)).+/,
  //     '$1'
  //   )
  // }
  return request({
    endpoint: component.validations.url,
    body: requiredValues,
    method: component.validations.method
  }).then(json => {
    if (component.name === 'INDIRIZZO') {
      const addressJson = {
        ...json.data,
        statusCode: json.data.status,
        status: json.status
      }

      if (
        !json.data.errorMessage &&
        !json.data.failureMessage &&
        !json.data.civicoFailureMessage
      ) {
        addressJson.status = 'success'
        addressJson.statusCode = 'ok'
      }

      if (json.status === 'error') {
        const missingAddressChunk = component.value
          .split(/\s+(?=(?:\d+|snc))/)
          .map((e, i) => i !== 0 && e)
          .filter(e => !!e)
          .join('')

        if (!!json.data.listIndirizzi && json.data.listIndirizzi.length > 0) {
          addressJson.values = [
            ...new Set([
              ...json.data.listIndirizzi.map(e => {
                if (/.+\s+(?:\d+|snc)/.test(e.indirizzo)) {
                  return e.indirizzo
                } else {
                  return `${e.indirizzo} ${missingAddressChunk}`
                }
              }),
              component.value
            ])
          ].map(s => ({
            label: s.toUpperCase(),
            value: s.toUpperCase()
          }))
        }
        addressJson.description = addressJson.message =
          json.data.errorMessage ||
          json.data.civicoFailureMessage ||
          json.data.warningMessage ||
          json.data.civicoWaringMessage ||
          `${component.cleanName} non validi`
      } else {
        json.description = addressJson.message = undefined
      }

      json = addressJson
    }
    const { status, message, values } = json
    const result = {
      status: [status]
    }

    if (json.hasOwnProperty('statusCode')) {
      result.status = [
        ...new Set([
          ...result.status,
          (() =>
            json.statusCode.toLowerCase() !== 'ko' &&
              json.statusCode.toLowerCase() !== '0001'
              ? 'success'
              : 'error')()
        ])
      ]
      result.errorMessage =
        json.statusCode.toLowerCase() !== 'ko' &&
          json.statusCode.toLowerCase() !== '0001'
          ? ''
          : json.description
      if (result.errorMessage.toLowerCase().indexOf('invalid otp') > -1) {
        result.errorMessage = ['OTP non valido']
      } else {
        result.errorMessage = [result.errorMessage]
      }
    }

    // @hack for CF to trigger login modal
    if (json.data && json.data.hasOwnProperty('login')) {
      result.loginRequired = json.data.login
    }

    // @hack for promoCode to trigger redirect on correct flow
    if (json.data && json.data.hasOwnProperty('redirect')) {
      result.redirectRequired = json.data.redirect
    }
    // if (component.name === "PromoCode") {
    //   console.log(json)
    // }
    if (status === 'error') {
      if(component.name === "PromoCode")
      {
        result.errorMessage=(!!json.error&&!!json.error.description)?[json.error.description]:""
        result.salesManId=""  
      }
      else
      {
      result.errorMessage = [message.replace('è invalido', 'non è valido')]
      }
    } else if (status === 'success') {
      result.errorMessage = ''
      if(component.name === "PromoCode")
      {
      result.salesManId=json.payLoad.SalesManId
      }
    }

    if (!!values) {
      result.values = values
    }

    return result
  })
}

/**
 * Fetches component values needed to autofill other components
 * @public
 * @param  {string} endpoint      The API endpoint that returns values
 * @param  {type} body            The information needed to get the required data
 * @param  {Guid} requestId       The requestId
 * @return {Promise}              The server response.json
 */
export const getAutofillValues = (endpoint, body, requestId) => {
  return request({ endpoint, body }).then(json => ({ ...json, requestId }))
}

export const checkContract = () => {
  return request({ endpoint: 'wgt/sign/check', body: {} })
}

/**
 * Acknowledges the contract
 * @public
 * @param  {Object} component     The component
 * @return {Promise}              ?
 */
export const acknowledgeContract = component => {
  const body = {
    stampeId: component.link.stampeId,
    barCode: component.link.barCode
  }
  return request({ endpoint: component.acknowledgement.url, body })
}

export const acknowledgePOSContract = state => {
  const url = 'wgt/product/onboarding/next'
  const body = {
    step: {
      number: state.step.number,
      widgets: [
        {
          code: state.widgets.DIFARMA_0.code,          
          components: [
            {
              name: 'check-attf',
              value: ''
            }
          ]
        }
      ]
    }
  }
  return request({ endpoint: url, body })
}

export const savePg = (pgRequest, stepNumber) => {
  let body = null
  const url = stepNumber === 3 ? 'wgt/acol/save' : 'wgt/acol/save/pg'
  body = {
    acolQuestionnaire: pgRequest.data.acolQuestionnaire
  }
  return request({ endpoint: url, body })
}

export const savePersonalizzaPOS = (widgets, stepNumber) => {
  let body = null
  const url = 'wgt/product/onboarding/next'
  body = {
    step: {
      number: stepNumber + '',
      widgets: widgets
    }
  }
  return request({ endpoint: url, body })
}

export const saveTitolare = (components, stepNumber, widgets) => {
  const titoWidget = widgets['TITOLARE_EFFETTIVO']
  let body = null
  const url = 'wgt/product/onboarding/next'
  body = {
    step: {
      number: stepNumber,
      widgets: [
        {
          code: titoWidget.code,
          components: components
        }
      ]
    }
  }
  return request({ endpoint: url, body })
}

/**
 * Gets the file preview for the provided uploader
 * @public
 * @param  {Object} component The component
 * @param  {Object} extraBody The formdata
 * @return {Promise}           [description]
 */
export const getFilePreview = (component, extraBody) => {
  let url = ''
  if (!!extraBody && !!extraBody.widgetId) {
    url = `genericfiledoc/previewGet/${extraBody.type}_${extraBody.widgetId}_${
      extraBody.docRefId
      }?r=${Math.random()}`
  } else {
    url = `wgt/document/preview/${component.uploadType}?v=${uuid()}`
    //url= `wgt/document/v2/preview/${component.uploadType}?r=`+Math.random() -- New one
  }
  const opt = {
    endpoint: url,
    method: 'GET',
    headers: { 'Content-Type': 'application/image' }
  }
  return request(opt).then(json => {
    if (json.status === 'success') {
      return json.data.url
    } else {
      return ''
    }
  })
}

/**
 * Uploads a file
 * @public
 * @param {string} base64URL     The base64 encoded string
 * @param {Enum} type            One of FRONT_DOC_1, BACK_DOC_1, FRONT_DOC_2, BACK_DOC_2, SELFIE
 * @param  {string} guid         The session guid
 * @param  {string} barCode      The document barCode
 * @return {Promise}             The server response.json
 */
export const uploadFile = (file, base64URL, type, guid, barCode, extraBody) => {
  let endpoint = null
  const base64chunks = base64URL.split(';')
  const base64 = base64chunks[1].replace('base64,', '')
  const contentType = !!file.type?file.type:base64chunks[0].replace('data:', '')
  const body = new FormData()

  if (extraBody && extraBody.docRefId) {
    body.append('type', extraBody.type)
  } else {
    body.append('type', type)
  }

  if (!!file.name) {
    body.append('file', b64toBlob(base64, contentType), file.name)
  } else {
    body.append('file', b64toBlob(base64, contentType), 'blob')
  }

  endpoint = 'wgt/document/upload'

  if (extraBody && extraBody.docRefId) {
    body.append('docRefId', extraBody.docRefId)
    body.append('widgetId', extraBody.widgetId)
    body.append('docType', extraBody.docType)
    endpoint = 'wgt/genericfiledoc/upload'
  }

  if (!!guid && !!barCode) {
    endpoint = 'wgt/contact/upload'
    body.append('guid', guid)
    body.append('barCode', barCode)
  }
  //Changes for loading new widget 
  if (type =='FRONT_DOC_')
  {
    body.append('widgetId', extraBody.widgetId)
    endpoint ='wgt/genericdocument/upload'
  }
  return request({ endpoint, body, headers: {} })
}

/**
 * Gets tim user info
 * @public
 * @param  {string} proof   Tim authorization code
 * @return {Promise}        userObject promise
 */
export const getTimUserInfo = proof => {
  const env = getEnv()

  const domain = {
    third: 'api',
    second: 'platfr',
    first: 'io'
  }

  switch (env) {
    case 'tst':
      domain.first = 'tst'
      break
    case 'pre':
      domain.third = 'sandbox'
      domain.first = 'io'
      break
    case 'pro':
      break
    default:
      domain.first = 'tst'
  }

  const body = {
    code: proof.code,
    state: proof.state
  }

  const endpoint = 'api/public/auth/v1/saminifo-tim'
  const method = 'GET'
  const apiRoot = `https://${domain.third}.${domain.second}.${domain.first}`
  return request({ endpoint, method, body, apiRoot })
}

/**
 * Sends an OTP to the provided recipient trough the provided channel
 * @public
 * @param  {string} channel      The message channel
 * @param  {string} recipient    The message recipient
 * @return {Promise}             otp delivery promise
 * @fulfil {Object}              Success response
 * @reject {Error}               Error response
 */
/*#Removed4POS*/
/*export const sendOtp = (channel, recipient) => {
  const endpoint = 'api/rest/FREE/otp/send'
  const apiRoot = API_ROOT.replace(/\/onboarding/, '')
  const body = {
    type: channel,
    typeValue: recipient,
    templateId: 'ONBOARDING OTP' // this template isn't valid anymore, infer it using the EXTRA value located in stateExtension.js
  }

  return request({
    endpoint,
    body,
    apiRoot
  })
}*/

/**
 * Notifies the onboarding completion to the specified tenant
 * @param  {string} contactId  contactId
 * @param  {string} name   step name
 * @return {Promise}           promise
 */
/*#Removed4POS*/
/*export const track = ({ contactId, name }) => {
  const endpoint = 'api/rest/FREE/onboarding/tracking'
  const apiRoot = API_ROOT.replace(/\/onboarding/, '')
  const body = {
    idPratica: contactId,
    state: name.toUpperCase()
  }

  return request({
    endpoint,
    apiRoot,
    body
  })
}*/

/**
 * Notifies the onboarding completion to the specified tenant
 * @param  {string} idPratica  contactId
 * @param  {string} phone      phone number
 * @param  {string} email      email
 * @param  {string} tenant     tenant
 * @return {Promise}           promise
 */
/*#Removed4POS*/
/*export const notifyCompletion = ({ idPratica, phone, email, tenant }) => {
  const endpoint = 'api/rest/FREE/onboarding/endup'
  const apiRoot = API_ROOT.replace(/\/onboarding/, '')
  const body = {
    idPratica,
    phone: phone.replace(/(?:\+\d\d)?(\d+)/, '$1'),
    email,
    tenant
  }

  return request({
    endpoint,
    apiRoot,
    body
  })
}*/
export const fetchIPAddress=()=>{
  return fetch("https://api.ipify.org?format=json").then(response=>response.json())
}

export const insertPromoCode = (promoCodeComp) => {
  let body = null
  if (promoCodeComp) {
    body = {
      Guid: promoCodeComp.Guid,
      ContactId: promoCodeComp.ContactId,
      MerchantName: promoCodeComp.MerchantName,
      PromoCode: promoCodeComp.PromoCode,
      CreationDate: promoCodeComp.CreationDate,
      ModifiedDate: promoCodeComp.ModifiedDate,
      CodiceFiscale: promoCodeComp.CodiceFiscale,
      VatNumber: promoCodeComp.VatNumber,
      SalesManId:promoCodeComp.SalesManID,
      FirstName:promoCodeComp.Nome,
      RagioneSociale: promoCodeComp.RagioneSociale,
      Email: promoCodeComp.Email,
      plan:promoCodeComp.PLAN,
      clientip:promoCodeComp.ClientIP,
      PRIVACYFK:promoCodeComp.PRIVACYFK
    }
  }

  return request({ endpoint: 'OnboardRequestDetails/InsertOnboardingDetails', body })
}
export const insertGUID = (requestBody) => {
  let body = null
  if (requestBody) {
    body = {
      Guid: requestBody.Guid,
      plan: requestBody.plan==='flex' ? 'flex' : requestBody.plan==='flexCRS'?'flexCRS':requestBody.plan==='flatCRS'?'flatCRS':requestBody.plan==='flexmini'?'flexmini':'flat'
    }
  }

  return request({ endpoint: 'OnboardRequestDetails/InsertOnboardingDetails', body })
}
//'https://sandbox.gestpay.net/PromocodesService/OnboardRequestDetails/InsertOnboardingDetails'
//https://172.17.4.63/magtek/OnboardRequestDetails/InsertOnboardingDetails
export const updatePromoCode = (promoCodeComp) => {
  let body = null
  if (promoCodeComp) {
    body = {
      ContactId: promoCodeComp.ContactId,
      Guid: promoCodeComp.Guid,
      PromoCode: promoCodeComp.PromoCode,
    }
  }

  return request({ endpoint: 'OnboardRequestDetails/UpdateOnboardingDetails', body })
}
//'https://sandbox.gestpay.net/PromocodesService/OnboardRequestDetails/UpdateOnboardingDetails'
//https://172.17.4.63/magtek/OnboardRequestDetails/UpdateOnboardingDetails
export const FetchPromoCode = (endpoint, body) => {
  return request({ endpoint: endpoint, method: "GET", body })
}
export const ValidatePromoCode = (endpoint, body) => {
  return request({ endpoint: endpoint, method: "POST", body })
}
export const FetchPOSPlan = (endpoint, body) => {
  return request({ endpoint: endpoint, method: "GET", body })
}
export const FetchPOSOnboardDetails = (endpoint, body) => {
  return request({ endpoint: endpoint, method: "GET", body })
}

/**
 * Update the Company address to the database
 * @param {Object} onBoardDetails        The current widgets
 * @return {Promise}              The server response.json
 */
export const updateOnboardingDetails = (onBoardDetails) => {
  let body = null
  if (onBoardDetails) {
    // body = {
    //   Guid: components.Guid,
    //   INSEGNA: components.INSEGNA,
    //   RAGIONESOCIALE: components.RAGIONESOCIALE,
    //   INDIRIZZO: components.INDIRIZZO,
    //   CITTA: components.CITTA,
    //   PROVINCIA: components.PROVINCIA
    // }
    body = onBoardDetails
  }

  return request({ endpoint: 'OnboardRequestDetails/UpdateOnboardingDetails', body })
}
export const SendMailWithPromoCode = (onBoardDetails) => {
  let body = null
  if (onBoardDetails) {
    body = onBoardDetails
  }

  return request({ endpoint: 'OnboardRequestDetails/SendEmail', body })
}
export const ValidateUser=(endpoint,body)=>{
  return request({ endpoint: endpoint, body:body })
}
export const UpdateReferalCode = (onBoardDetails) => {
  let body = null
  if (onBoardDetails) {
    body = onBoardDetails
  }
  return request({ endpoint: 'OnboardRequestDetails/UpdateReferalCode', body })
}
//Meta Data API wgt/product/onboarding/metadata
export const Metadata = (body) => {
  return request({ endpoint: 'wgt/product/onboarding/metadata', body })
}


// WEBPACK FOOTER //
// ./state/api.js